import React from "react";
import { RichTextView } from "../../../../editor/RichTextView/RichTextView";
import { Text } from "../../../../typography/Text";
import { FormattedMessage } from "react-intl";

const msgKey = "paperDocPreview";

export const PaperDocPreview = ({ document }) => {
    return (
        <div style={{ border: "1px solid #ccc", borderRadius: "4px" }}>
            <div style={{ borderBottom: "1px solid #eee", padding: "10px 15px", fontWeight: "bold" }}>
                {document?.title}
            </div>
            <div style={{ padding: "15px" }}>
                {document?.body && document?.body?.trim() !== "" ? (
                    <RichTextView html={document.body} />
                ) : (
                    <Text color="base60">
                        <FormattedMessage id={`${msgKey}.emptyDocument`} defaultMessage="Empty document" />
                    </Text>
                )}
            </div>
        </div>
    );
};
